import { Component, OnInit } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { BullhornEntityFiltersComponent } from '../bullhorn.entity-filters.component';
import { BullhornPlacementFiltersService } from './bullhorn.placement-filters.service';

@Component({
  selector: 'app-bullhorn-placement-filters',
  templateUrl: '../bullhorn.entity-filters.component.html',
  styleUrls: ['../bullhorn.entity-filters.component.scss'],
  standalone: false,
})
export class BullhornPlacementFiltersComponent extends BullhornEntityFiltersComponent {
  constructor(protected service: BullhornPlacementFiltersService, protected messageNotificationService: MessageNotificationService) {
    super(service, messageNotificationService);
  }
}
